.reference {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  outline: none;
}

.reference:focus-visible {
  outline: 3px solid var(--color-focus-ring);
  outline-offset: 3px;
}


.details { text-align: start; }
